import { deleteItem, getList, postItem } from "./generics";
import { fetchAuthenticated } from "./utils";
import { getAbsoluteUrl } from "./urls";
import { FAILED } from "../utils/constants/tags";
import WebhookEndpoint from "../models/webhook-endpoint";

export const getWebhookEndpointList = (taxPayerId: number) => {
  const additionalParams = new Map<string, string>();
  additionalParams.set("tax_payer_id", taxPayerId.toString());
  return getList<WebhookEndpoint>("/webhook_endpoints/", 100, 0, additionalParams);
};

export const createWebhookEndpoint = (data: WebhookEndpoint) => {
  return postItem("/webhook_endpoints/create/", data);
};

export const updateWebhookEndpoint = async (
  id: number,
  data: Partial<WebhookEndpoint>
) => {
  const fullUrl = getAbsoluteUrl(`/webhook_endpoints/${id}/`);
  try {
    const response = await fetchAuthenticated(fullUrl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PATCH",
      credentials: "include",
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch {
    return { status: FAILED, detail: "Server not Found" };
  }
};

export const deleteWebhookEndpoint = (id: number) => {
  return deleteItem(`/webhook_endpoints/${id}/`, {});
};

export interface WebhookEndpointTestResult {
  responseStatus: number | null;
  responseBody: string;
  delivered: boolean;
}

export const testWebhookEndpoint = (id: number) => {
  return postItem<{}>(`/webhook_endpoints/${id}/test/`, {});
};
